<template>
  <div class="footer">
    <div class="contact-us">{{ $t('contactUs') }}</div>
    <div class="address">{{ $t('address') }}</div>
    <div class="contact">
      <div class="contact-info">
        <div class="contact-item">
          <div class="label"> {{ $t('phoneLabel') }}</div>
          <div class="value"> {{ $t('phoneNumber') }}</div>
        </div>
        <div class="contact-item">
          <div class="label">{{ $t('emailLabel') }}</div>
          <div class="value">{{ $t('emailAddress') }}</div>
        </div>
      </div>
      <img class="footer-logo" src="@/assets/image/activity/footer-logo.png">
    </div>
  </div>
</template>

<script>
export default {
  i18n: {
    messages: {
      en: {
        contactUs: 'Contact Us',
        address: 'ONE WOLTER PLACE Lantai M, Jl. Wolter Monginsidi No.63B, RT.1/RW.1, Rw. Bar., Kby. Baru, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12180',
        phoneLabel: 'Telephone: ',
        phoneNumber: '+62 813-2488-7208',
        emailLabel: 'E-mail: ',
        emailAddress: 'pendanaan@kreditpintar.com',
      },
      id: {
        contactUs: 'Hubungi Kami',
        address: 'ONE WOLTER PLACE Lantai M, Jl. Wolter Monginsidi No.63B, RT.1/RW.1, Rw. Bar., Kby. Baru, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12180',
        phoneLabel: 'Telepon: ',
        phoneNumber: '+62 813-2488-7208',
        emailLabel: 'E-mail: ',
        emailAddress: 'pendanaan@kreditpintar.com',
      },
    },
  },
}
</script>

<style scoped lang="stylus">
.footer {
  background-color: #363B36;
  color: #fff;
  padding: 40px 24px 90px;
  .contact-us {
    line-height: 16px;
    font-weight: 500;
    margin-bottom: 10px;
  }
  .address {
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 18px;
  }
  .contact {
    display: flex;
    justify-content: flex-start;
    .contact-info {
      margin-right: 20px;
      .contact-item {
        display: flex;
        justify-content: flex-start;
        font-size: 12px;
        &:first-child {
          margin-bottom: 15px;
        }
        .label {
          font-weight: 500;
          margin-right: 10px;
        }
      }
    }
    .footer-logo {
      width: 40px;
      height: 40px;
    }
  }
}
</style>
